import React from 'react';
import messages from "res/messages/farsi";
import {useHistory} from "react-router-dom";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import IconTitleButton from "components/buttons/IconTitleButton";
import {IsF, IsLP_MP_SP, IsM, IsSM, IsT} from "my-styles/media/media";

import ICLogo from 'res/images/logo_persian.png';
import ICInstagram from "res/images/instagram_colored.png";
import ICSelect from "res/images/select.png";
import ICLanding from "res/images/landing_bg.png";
import ICLandingMobile from "res/images/landing_mobile_bg.png";
import ICCafeBazzar from 'res/images/cafe_bazzar_dark.png';
import ICGooglePlay from 'res/images/google_play_dark.png';

export default function Landing(props) {

    const history = useHistory()

    return (<div style={{backgroundColor: "var(--yellow_2)", height: "80em"}}>
        {IsLP_MP_SP() &&
        <div className="card" style={{
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundImage: 'url(' + ICLanding + ')',
            width: "80%",
            position: "absolute",
            top: "7.5%",
            left: "10%"
        }}>
            <div style={{position: "absolute", top: "1%", left: "1%"}}>
                <IconTitleButton
                    direction={"rtl"}
                    fontSize="xLargeTextBold"
                    hover="var(--white)"
                    textcolor="var(--white)"
                    icon={<img src={ICInstagram} alt={"صرفه مارکت"} className="largeIcon"/>}
                    title={messages.sarfeMarketEn}
                    onClick={() => {
                        window.open(messages.instagramLink, "_blank")
                    }}/>
            </div>
            <table className="marginSmall oneFromThree">
                <tbody>
                <tr>
                    <td>
                        <img className="clickable appLogoLarge"
                             src={ICLogo} alt=""
                             onClick={() => {
                                 props.onNavigate(history, '/')
                             }}/>
                    </td>
                </tr>
                <tr className="center">
                    <td className="blueColor_7 xxxxLargeTextBold">
                        {messages.internetStore}
                    </td>
                </tr>
                <tr className="center">
                    <td className="blueColor_7 xxxLargeTextBold">
                        {messages.sarfeMarket}
                    </td>
                </tr>
                <tr className="center">
                    <td className="yellowColor_3 xxxxxLargeTextBold">
                        {messages.justByNow}
                    </td>
                </tr>
                <tr>
                    <td>
                        <div className="marginTopSmall marginRightSmall">
                            <div className="horizontalScreen">
                                <img src={ICSelect} alt="" className="smallIcon"/>
                                <div className="marginRightSmall grayColor xLargeTextBold">
                                    {messages.allKindsDetergentProducts}
                                </div>
                            </div>
                            <div className="horizontalScreen">
                                <img src={ICSelect} alt="" className="smallIcon"/>
                                <div className="marginRightSmall grayColor xLargeTextBold">
                                    {messages.lowerPrice}
                                </div>
                            </div>
                            <div className="horizontalScreen">
                                <img src={ICSelect} alt="" className="smallIcon"/>
                                <div className="marginRightSmall grayColor xLargeTextBold">
                                    {messages.famusBrand}
                                </div>
                            </div>
                            <div className="horizontalScreen">
                                <img src={ICSelect} alt="" className="smallIcon"/>
                                <div className="marginRightSmall grayColor xLargeTextBold">
                                    {messages.likeOnline}
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr className="center">
                    <td>
                        <div className="marginTopMedium">
                            <IconTitleButtonRound
                                backgroundcolor={"var(--yellow_3)"}
                                height={"2.5em"}
                                width={"50%"}
                                fontSize="xLargeTextBold"
                                onClick={() => {
                                    props.onNavigate(history, '/')
                                }}
                                title={messages.orderRegister}/>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div className="marginTopMedium horizontalScreen">
                            <div className="toLeft marginSmall downloadButtonSmall">
                                <img className="full clickable" src={ICGooglePlay} alt=""
                                     onClick={() => {
                                         window.open(messages.googlePlayLink)
                                     }}/>
                            </div>
                            <div className="toLeft marginSmall downloadButtonSmall">
                                <img className="full clickable" src={ICCafeBazzar} alt=""
                                     onClick={() => {
                                         window.open(messages.cafeBazaarLink)
                                     }}/>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        }
        {IsT() &&
        <div className="card" style={{
            width: "80%",
            position: "absolute",
            top: "7.5%",
            left: "10%"
        }}>
            <div style={{
                width: "100%",
                height: "35em",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundImage: 'url(' + ICLandingMobile + ')',
            }}>
                <div style={{position: "absolute", top: "0.5%", left: "1%"}}>
                    <IconTitleButton
                        direction={"rtl"}
                        fontSize="largeTextBold"
                        hover="var(--white)"
                        textcolor="var(--white)"
                        icon={<img src={ICInstagram} alt={"صرفه مارکت"} className="largeIcon"/>}
                        title={messages.sarfeMarketEn}
                        onClick={() => {
                            window.open(messages.instagramLink, "_blank")
                        }}/>
                </div>
                <table className="paddingSmall">
                    <tbody>
                    <tr>
                        <td>
                            <img className="clickable"
                                 style={{width: "7em"}}
                                 src={ICLogo} alt=""
                                 onClick={() => {
                                     props.onNavigate(history, '/')
                                 }}/>
                        </td>
                    </tr>
                    <tr className="center">
                        <td className="blueColor_7 xxxLargeTextBold">
                            {messages.internetStore} {" "} {messages.sarfeMarket}
                        </td>
                    </tr>
                    <tr className="center">
                        <td className="yellowColor_3 xxxLargeTextBold">
                            {messages.justByNow}
                        </td>
                    </tr>
                    <tr className="center">
                        <td>
                            <div className="marginTopSmall">
                                <IconTitleButtonRound
                                    backgroundcolor={"var(--yellow_3)"}
                                    height={"2.5em"}
                                    width={"50%"}
                                    fontSize="xLargeTextBold"
                                    onClick={() => {
                                        props.onNavigate(history, '/')
                                    }}
                                    title={messages.orderRegister}/>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="full">
                <table className="marginSmall oneFromThree">
                    <tbody>
                    <tr>
                        <td>
                            <div className="marginTopSmall marginRightSmall">
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="smallIcon_1"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.allKindsDetergentProducts}
                                    </div>
                                </div>
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="smallIcon_1"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.lowerPrice}
                                    </div>
                                </div>
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="smallIcon_1"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.famusBrand}
                                    </div>
                                </div>
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="smallIcon_1"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.likeOnline}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="marginTopSmall horizontalScreen">
                                <div className="marginSmall downloadButtonSmall">
                                    <img className="full clickable" src={ICGooglePlay} alt=""
                                         onClick={() => {
                                             window.open(messages.googlePlayLink)
                                         }}/>
                                </div>
                                <div className="marginSmall downloadButtonSmall">
                                    <img className="full clickable" src={ICCafeBazzar} alt=""
                                         onClick={() => {
                                             window.open(messages.cafeBazaarLink)
                                         }}/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        }
        {IsF() &&
        <div className="card" style={{
            width: "80%",
            position: "absolute",
            top: "7.5%",
            left: "10%"
        }}>
            <div style={{
                width: "100%",
                height: "35em",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundImage: 'url(' + ICLandingMobile + ')',
            }}>
                <div style={{position: "absolute", top: "0", left: "0"}}>
                    <IconTitleButton
                        direction={"rtl"}
                        fontSize="largeTextBold"
                        hover="var(--white)"
                        textcolor="var(--white)"
                        icon={<img src={ICInstagram} alt={"صرفه مارکت"} className="largeIcon"/>}
                        title={messages.sarfeMarketEn}
                        onClick={() => {
                            window.open(messages.instagramLink, "_blank")
                        }}/>
                </div>
                <table className="paddingSmall">
                    <tbody>
                    <tr>
                        <td>
                            <img className="clickable"
                                 style={{width: "6em"}}
                                 src={ICLogo} alt=""
                                 onClick={() => {
                                     props.onNavigate(history, '/')
                                 }}/>
                        </td>
                    </tr>
                    <tr className="center">
                        <td className="blueColor_7 xxLargeTextBold">
                            {messages.internetStore} {" "} {messages.sarfeMarket}
                        </td>
                    </tr>
                    <tr className="center">
                        <td className="yellowColor_3 xxLargeTextBold">
                            {messages.justByNow}
                        </td>
                    </tr>
                    <tr className="center">
                        <td>
                            <div className="marginTopSmall">
                                <IconTitleButtonRound
                                    backgroundcolor={"var(--yellow_3)"}
                                    height={"2.5em"}
                                    width={"50%"}
                                    fontSize="xLargeTextBold"
                                    onClick={() => {
                                        props.onNavigate(history, '/')
                                    }}
                                    title={messages.orderRegister}/>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <table className="marginSmall oneFromThree">
                    <tbody>
                    <tr>
                        <td>
                            <div className="marginTopSmall marginRightSmall">
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="xSmallIcon"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.allKindsDetergentProducts}
                                    </div>
                                </div>
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="xSmallIcon"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.lowerPrice}
                                    </div>
                                </div>
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="xSmallIcon"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.famusBrand}
                                    </div>
                                </div>
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="xSmallIcon"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.likeOnline}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="marginTopSmall horizontalScreen">
                                <div className="marginSmall downloadButtonSmall">
                                    <img className="full clickable" src={ICGooglePlay} alt=""
                                         onClick={() => {
                                             window.open(messages.googlePlayLink)
                                         }}/>
                                </div>
                                <div className="marginSmall downloadButtonSmall">
                                    <img className="full clickable" src={ICCafeBazzar} alt=""
                                         onClick={() => {
                                             window.open(messages.cafeBazaarLink)
                                         }}/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        }
        {(IsSM() || IsM()) &&
        <div className="card" style={{
            width: "86%",
            position: "absolute",
            top: "8%",
            left: "7%"
        }}>
            <div style={{
                width: "100%",
                height: "30em",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundImage: 'url(' + ICLandingMobile + ')',
            }}>
                <div style={{position: "absolute", top: "0", left: "0"}}>
                    <IconTitleButton
                        direction={"rtl"}
                        fontSize="largeTextBold"
                        hover="var(--white)"
                        textcolor="var(--white)"
                        icon={<img src={ICInstagram} alt={"صرفه مارکت"}className="smallIcon"/>}
                        title={messages.sarfeMarketEn}
                        onClick={() => {
                            window.open(messages.instagramLink, "_blank")
                        }}/>
                </div>
                <table className="paddingSmall">
                    <tbody>
                    <tr>
                        <td>
                            <img className="clickable"
                                 style={{width: "5em"}}
                                 src={ICLogo} alt=""
                                 onClick={() => {
                                     props.onNavigate(history, '/')
                                 }}/>
                        </td>
                    </tr>
                    <tr className="center">
                        <td className="blueColor_7 xxLargeTextBold">
                            {messages.internetStore} {" "} {messages.sarfeMarket}
                        </td>
                    </tr>
                    <tr className="center">
                        <td className="yellowColor_3 xxLargeTextBold">
                            {messages.justByNow}
                        </td>
                    </tr>
                    <tr className="center">
                        <td>
                            <div className="marginTopSmall">
                                <IconTitleButtonRound
                                    backgroundcolor={"var(--yellow_3)"}
                                    height={"2em"}
                                    width={"50%"}
                                    fontSize="xLargeTextBold"
                                    onClick={() => {
                                        props.onNavigate(history, '/')
                                    }}
                                    title={messages.orderRegister}/>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <table className="fullWidth">
                    <tbody>
                    <tr>
                        <td>
                            <div className="marginTopSmall marginRightSmall">
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="xSmallIcon_1"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.allKindsDetergentProducts}
                                    </div>
                                </div>
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="xSmallIcon_1"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.lowerPrice}
                                    </div>
                                </div>
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="xSmallIcon_1"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.famusBrand}
                                    </div>
                                </div>
                                <div className="horizontalScreen">
                                    <img src={ICSelect} alt="" className="xSmallIcon_1"/>
                                    <div className="marginRightSmall grayColor xLargeTextBold">
                                        {messages.likeOnline}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="marginTopSmall horizontalFullScreen">
                                <div className="marginSmall downloadButtonSmall">
                                    <img className="full clickable" src={ICGooglePlay} alt=""
                                         onClick={() => {
                                             window.open(messages.googlePlayLink)
                                         }}/>
                                </div>
                                <div className="marginSmall downloadButtonSmall">
                                    <img className="full clickable" src={ICCafeBazzar} alt=""
                                         onClick={() => {
                                             window.open(messages.cafeBazaarLink)
                                         }}/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        }
    </div>)

}